import React from 'react';
import { useLocale } from 'locale';
import {
  HistoryItem,
  IPriceEstimationRecord,
  PricesAccordionTab,
  PricesBedsFilter,
  PricesSectionType,
  PricesYearFilter,
} from 'store/state/selectors/insights/prices';
import { PaginationType } from 'ds/components/pagination';
import { Text } from 'ds/components/typography';
import PricesTable from 'components/widget/prices/prices-table';
import { TableWrapper, BodyWrapper, TableFiltersWrapper } from './styled';
import { filterFn, WIDGET_DESKTOP_TABLE_ROWS, WIDGET_MOBILE_TABLE_ROWS } from 'components/widget/prices/utils';
import PricesSummaryFilters from 'components/widget/prices/filters';
import { marketplaceSelector } from 'store/state/selectors/router';
import { useSelector } from 'react-redux';


interface TabBodyProps {
  tab: PricesAccordionTab;
  sectionId: PricesSectionType;
  currentBulletinId: string;
  yearFilter: PricesYearFilter;
  bedsFilter: PricesBedsFilter;
  showOnlyFinalTransactionsFilter: boolean;
  projectId: string;
  projectIds: string[];
  pricesTableChildren?: React.ReactNode;
  paginationType?: PaginationType;
  visibleRowsMobile?: number;
  visibleRowsDesktop?: number;
}

const TabBody: React.FC<TabBodyProps> = ({
  showOnlyFinalTransactionsFilter,
  currentBulletinId,
  yearFilter,
  bedsFilter,
  sectionId,
  tab,
  projectId,
  projectIds,
  pricesTableChildren,
  paginationType,
  visibleRowsMobile = WIDGET_MOBILE_TABLE_ROWS,
  visibleRowsDesktop = WIDGET_DESKTOP_TABLE_ROWS,
}) => {
  const { t } = useLocale();
  const marketplace = useSelector(marketplaceSelector);
  const data: Array<HistoryItem | IPriceEstimationRecord> = tab.tableData;
  const isEmpty = !data.filter(i => i.id !== currentBulletinId).length;
  const filteredData = filterFn({ bedsFilter, showOnlyFinalTransactionsFilter, yearFilter }, tab.tableData, currentBulletinId, marketplace);

  return (
    <BodyWrapper>
      {isEmpty
        ? <Text>{t('widget.prices.comparableTable.noData', { tab: tab.tabId })}</Text>
        : (
          <TableWrapper>
            <TableFiltersWrapper>
              <PricesSummaryFilters
                sectionId={sectionId}
                tab={tab}
              />
            </TableFiltersWrapper>
            <PricesTable
              tab={{ tabId: tab.tabId, tableData: filteredData }}
              paginationType={paginationType}
              visibleRowsMobile={visibleRowsMobile}
              visibleRowsDesktop={visibleRowsDesktop}
              projectId={projectId}
              projectIds={projectIds}
            >
              {pricesTableChildren}
            </PricesTable>
          </TableWrapper>
        )
      }
    </BodyWrapper>
  );
};

export default TabBody;
